/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import Find from './find.mdx';
import FindAll from './find-all.mdx';
import EnzymeFind from './enzyme-find.mdx';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "测试实用工具(Test Utilities)"
    }), "\n", _jsx(_components.p, {
      children: "¥Test Utilities"
    }), "\n", _jsx(Find, {}), "\n", _jsx(FindAll, {}), "\n", _jsx(EnzymeFind, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
